// we cannot have a generalize loadFile for both.md and .xml because of this reason

import { basePath } from '../basePath';

// https://github.com/rollup/plugins/tree/master/packages/dynamic-import-vars#limitations
export const loadMd = async (filePath: string) => {
  if (filePath) {
    try {
      // Dynamically import the file with the specified extension
      const response = await fetch(`/${basePath}/${filePath}.md`);
      const text = await response.text();
      return text;
    } catch (error) {
      console.error(`Error loading ${filePath}.md:`, error);
    }
  }
};
